import { Component, ViewEncapsulation } from '@angular/core';
import { UIBlockingService } from '../core/ui-blocking.service';
import { Observable, merge } from 'rxjs';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { ToastNotificationService } from '../core/toast-notification.service';
import { DumbPendingApplication } from './DTOs/dumb-pending-application';
import { GetPendingApplicationsRequest } from './DTOs/get-pending-applications-request';
import { PendingApplicationDtRetInfo } from './DTOs/pending-applications-dt-ret-info';
import { PendingApplicationsService } from './pending-applications.service';

@Component({
    selector: 'app-pending-applications',
    templateUrl: './pending-applications.component.html',
    providers: [UIBlockingService, NgbDropdown],
    encapsulation: ViewEncapsulation.None
})
export class PendingApplicationsComponent {
    constructor(private pendingApplicationsService: PendingApplicationsService,
        private blockUI: UIBlockingService,
        private notificationService: ToastNotificationService) {
    }

    applications: DumbPendingApplication[] = [];
    totalApps = 0;
    filteredApps = 0;
    pageNum = 1;
    itemsPerPage = 10;
    searchText = "";
    statusSearch = { display: "Pending", value: 1 };
    sortType = -1;
    keywordSearches: string[] = [];
    filtersChanged = true;
    initialLoad = true;

    get currentPageNum() { return this.pageNum };
    set currentPageNum(page: number) {
        this.pageNum = page;
        if (!this.initialLoad)
            this.getPendingApps();
    }
    get itemStart() {
        return ((this.currentPageNum - 1) * this.itemsPerPage) + 1;
    }
    get itemEnd() {
        return ((this.currentPageNum - 1) * this.itemsPerPage) + this.applications.length;
    }

    ngOnInit() {
        var observablesMerged = merge(this.getPendingAppsObservable());
        this.blockUI.start();
        observablesMerged.subscribe(
            {
                next: (data) => {
                    this.applications = data.data;
                    this.totalApps = data.recordsTotal;
                    this.filteredApps = data.recordsFiltered;
                    this.initialLoad = false;
                },
                error: (err) => {
                    this.notificationService.error(err.error.message);
                    this.blockUI.stop();
                    console.log(err)
                },
                complete: () => {
                    this.blockUI.stop();
                }
            });
    }
    getPendingAppsObservable(): Observable<PendingApplicationDtRetInfo> {
        var req = this.createSearchRequest();
        return this.pendingApplicationsService
            .getAllPendingApplications(req);
    }

    getPendingApps() {
        this.blockUI.start();

        this.getPendingAppsObservable()
            .subscribe(
                {
                    next: (data) => {
                        this.applications = data.data;
                        this.totalApps = data.recordsTotal;
                        this.filteredApps = data.recordsFiltered;
                    },
                    error: (err) => {
                        this.notificationService.error(err.error.message);
                        this.blockUI.stop();
                        console.log(err)
                    },
                    complete: () => {
                        this.blockUI.stop();
                    }
                });
    }

    createSearchRequest(): GetPendingApplicationsRequest {
        var req = new GetPendingApplicationsRequest();

        if (this.filtersChanged)
            this.pageNum = 1;

        req.PageNumber = this.pageNum - 1; //to get the 0-indexed number
        req.ItemsPerPage = this.itemsPerPage;

        req.KeywordSearches = this.keywordSearches;
        req.Sorting = this.sortType;

        req.StatusSort = this.statusSearch.value;

        this.filtersChanged = false;

        return req;
    }

    enterSearchTerm(event: any) {
        if (event.keyCode != 13)//13 is enter
            return;

        this.searchText.trim().split(' ').forEach((term) => this.keywordSearches.push(term));
        this.searchText = '';
        this.filtersChanged = true;
        this.getPendingApps();
        return;
    }

    removeSearchTerm(term: string) {
        var index = this.keywordSearches.indexOf(term);
        if (index != -1) {
            this.keywordSearches.splice(index, 1);
            this.filtersChanged = true;
        }
        this.getPendingApps();
    }

    clearSearch() {
        this.searchText = "";
        this.statusSearch = { display: "Pending", value: 1 };
        this.sortType = 1;
        this.keywordSearches = [];
        this.filtersChanged = true;
        this.getPendingApps();
    }
    hitSearchBtn() {
        this.searchText.trim().split(' ').forEach((term) => this.keywordSearches.push(term));
        this.searchText = '';
        this.filtersChanged = true;
        this.getPendingApps();
    }
    changeSortType(column: number) {
        switch (column) {
            case 1:
                if (this.sortType == 1)
                    this.sortType = 2;
                else this.sortType = 1;
                break;
            case 2:
                if (this.sortType == 3)
                    this.sortType = 4;
                else this.sortType = 3;
                break;
            case 3:
                if (this.sortType == 5)
                    this.sortType = 6;
                else this.sortType = 5;
                break;
            case 4:
                if (this.sortType == 7)
                    this.sortType = 8;
                else this.sortType = 7;
                break;
            case 5:
                if (this.sortType == 9)
                    this.sortType = 10;
                else this.sortType = 9;
                break;
            default:
                break;
        }
        this.filtersChanged = true;
        this.getPendingApps();
    }
    changeStatusSearch(toChange: number) {
        if (this.statusSearch.value == toChange)
            return;

        this.filtersChanged = true;
        switch (toChange) {
            case -1:
                this.statusSearch = { display: "All", value: -1 };
                break;
            case 1:
                this.statusSearch = { display: "Pending", value: 1 };
                break;
            case 2:
                this.statusSearch = { display: "Approved", value: 2 };
                break;
            case 3:
                this.statusSearch = { display: "Denied", value: 3 };
                break;
            default:
                this.statusSearch = { display: "Pending", value: 1 };
                break;
        }
        this.getPendingApps();
    }

}
